import {
  AnalyticsEventPropTypes,
  ACTIONS,
  activity,
  eventDetailVersion
} from '@uma/react-commons/dist/index';
import { screenPath, screenName } from 'src/utils/analytics';

export const SecurityScreenDisplayed: AnalyticsEventPropTypes = {
  action: ACTIONS.SCREEN_DISPLAYED,
  activity,
  screenPath,
  screenName,
  version: eventDetailVersion
};
